/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
import { getContext } from "redux-saga/effects";
import { call } from "typed-redux-saga";
import { CMSClientType } from "@/cms-api";
import { ProcessAction } from "@centralwebteam/narwhal";

export const data = {
  fetchOffsetAdjustment: function* fetchOffsetAdjustment({
    from,
    to,
    take,
  }: {
    from: string;
    to: string;
    take: number;
  }) {
    const client: CMSClientType = yield getContext("client");
    const allProcessActions = yield* call(
      () =>
        client.events.processActions.all({
          query: { from, to, take },
        }).promise
    );

    return allProcessActions.filter(containsRequiredProperties);
  },
};

function containsRequiredProperties(processAction: ProcessAction): boolean {
  if (processAction.id === undefined || processAction.details === undefined) {
    return false;
  }

  const { details } = processAction;

  if (
    processAction.grouping === "Characteristic" &&
    details.sourceMachine === undefined
  ) {
    return false;
  }

  return (
    details.analysisTrigger !== undefined &&
    details.processTarget !== undefined &&
    details.offsetTarget !== undefined &&
    details.executionSettings !== undefined
  );
}
